import { useEffect, useState, type RefObject } from 'react'

/**
 * True from the moment `signal` is bumped (the lock notice's Release, AB#301) until the member's
 * next input inside `ref`'s element (a press, a key, the wheel): while true, the editor publishes
 * no human lock. The twin of useIdle — the member lets go by choice instead of by waiting — so
 * working again simply takes the lock back. `signal` 0 = never released.
 */
export function useReleased(ref: RefObject<HTMLElement | null>, signal: number): boolean {
  const [released, setReleased] = useState(false)
  useEffect(() => {
    if (signal === 0) return
    setReleased(true)
    const onInput = (e: Event): void => {
      if (ref.current?.contains(e.target as Node)) setReleased(false)
    }
    const inputs = ['pointerdown', 'mousedown', 'keydown', 'wheel'] as const
    for (const type of inputs) document.addEventListener(type, onInput, true)
    return () => {
      for (const type of inputs) document.removeEventListener(type, onInput, true)
    }
  }, [ref, signal])
  return released
}
